<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">会员卡详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="cardInfo">
                <div class="shopName">{{ shopInfo.name }}</div>
                <div class="cardBack" @click="changeCard" v-if="isFront">
                    <div class="memberCard">
                        <div class="memberName">
                            <div class="uname">会员名：{{ cardInfo.nick }}</div>
                            <div class="cname">{{ cardInfo.cardInfo.cardName }}</div>
                        </div>
                        <div>
                            <i class="star"></i>
                        </div>
                        <div class="cInfo">
                            <span>余额：</span>
                            <span>{{ cardInfo.balance }}元</span>
                            <span>积分：{{ cardInfo.point }}分</span>                            
                            <span v-if="cardInfo.cardInfo.rateDiscount != 100">{{ cardInfo.cardInfo.rateDiscount / 10.0 }}折</span>
                            <span v-else>无折扣</span>
                            <span>生日：{{ cardInfo.birthday | moment('YYYY年MM月DD日')  }}</span>
                        </div>
                    </div>
                    <img class="Qcode" src="../../assets/images/Qcode.png" alt="" @click.stop="getQRcode">
                    <span class="more" @click.stop="goMorePage">更多</span>
                </div>                
                <div class="card" @click="changeCard" v-else>
                    <div class="memberCard">
                        <img class="cImg" src="../../assets/images/bg-one.jpg" alt="">
                        <span class="cardShare" v-show="cardInfo.cardInfo && cardInfo.cardInfo.isShare != 0">共享会员卡</span>
                        <span class="cardNum">编号：{{ cardInfo.cardShow }}</span>
                    </div>
                    <img class="Qcode" src="../../assets/images/Qcode.png" alt="" @click.stop="getQRcode" >
                    <span class="more" @click.stop="goMorePage">更多</span>
                </div>
                <!-- 二维码展开 -->
                <div class="bigPic" v-show="!active">
                    <qrcanvas :options="{ cellSize: 8, data: src}"></qrcanvas>
                    <div class="serial">{{ cardInfo.cardShow }}</div>
                </div>
                <div class="list">
                    <ul>
                        <li>
                            <img src="../../assets/images/localIcon.png" alt="">
                            <span>{{ shopInfo.address }}</span>
                            <img @click="sheetVisible = true" src="../../assets/images/tel.png" alt="">
                        </li>
                        <li @click="goXiaoFeiListPage">
                            <img src="../../assets/images/consumeIcon.png" alt="">
                            <span >消费记录</span>
                            <i class="el-icon-arrow-right"></i>
                        </li>
                    </ul>
                </div>
                <div class="select">
                    <ul>
                        <li @click="goSharePage">
                            <img src="../../assets/images/inviteIcon.png" alt="">
                            <span>邀请好友</span>
                            <span>共享此卡</span>
                        </li>
                        <li @click="goChainShopPage">
                            <img src="../../assets/images/shopIcon.png" alt="">
                            <span>连锁门店</span>
                        </li>
                        <li @click="goDiscountPage">
                            <img src="../../assets/images/discountIcon.png" alt="">
                            <span>&nbsp;&nbsp;&nbsp;优惠</span>
                        </li>
                        <li @click="goPreOrderPage">
                            <img src="../../assets/images/orderIcon.png" alt="">
                            <span>&nbsp;&nbsp;&nbsp;预约</span>
                        </li>
                    </ul>
                </div>
            </div>
            <span class="yushou">预售项目</span>
            <div class="yushouList">
                <ul>
                    <li v-for="(product, key) in productsInfo" :key="key">
                        <div class="yushouItem">
                            <span>{{ product.name }}</span>：
                            <span>{{ product.count }}</span>
                            <span>截止至{{ product.endtime | moment('YYYY.MM.DD') }}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <span class="area">活动专区</span>
            <div class="activity">
                <div class="item" @click="goActivityDetail" v-if="activityInfo.name">
                    <img :src="activityInfo.picName" alt="">
                    <div class="explain">
                        <span>{{ activityInfo.name }}</span>
                        <span>有效期：{{ activityInfo.beginTime | moment('YYYY.MM.DD') }}-{{ activityInfo.endTime | moment('YYYY.MM.DD') }}</span>
                    </div>
                </div>
                <div class="noData1" v-else>
                    <span class="iconfont icon-wushuju icon-nodata"></span>
                    <span>暂无活动，敬请期待！</span>
                </div>
            </div>
        </div>
        <!-- 电话弹框 -->
        <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio, Navbar, TabItem ,Actionsheet } from "mint-ui";
//import store from "@/vuex/store";
//import { mapState } from "vuex"; 
import global from "../../../static/js/global";
import config from "../../../static/js/config";
import { showCardAction, showCardDetailedAction, showOrderListAction, showBarCodeAction, showActivityAction } from '../../assets/js/api'
import Qrcanvas from 'qrcanvas-vue'
import { regularToast } from '../../assets/js/utilities'

export default {
    data() {
    return {  
        isFront:false, 
        active:true,
        sheetVisible: false,
        src:"",                    // 二维码图片路径 
        actions:[],
        index:"",                  // 索引
        sid: 0,
        size: 200,

        productsInfo:[],           // 商品信息
        shopInfo:[],               // 店铺信息
        cardInfo:[],               // 会员卡信息
        activityInfo:[],           // 活动信息

        cShowName:"",              // 会员卡名称
        cardData:[],               // 路由跳转带过来的会员卡数据
        beginIdx:0,                // 分页的开始值
        num:0,                     // 分页次数
        loading:true,              // 是否加载
        activityList:[],           // 活动列表
        instance:Toast({
            message: '加载中....',
            position: 'middle',
            duration:-1
        }),
    };
    },
  components: {
    Qrcanvas
  },
    methods: { 
        //切换卡面
        changeCard(){

            if(this.isFront == false){
                this.isFront = true;
            }else{
                this.isFront = false;
            }
        },
        //跳转到更多服务页
        goMorePage(){
            this.$router.push({ name:"more" })
        },
        //跳转到活动详情页
        goActivityDetail(){
            this.$router.push({ name:"activityDetail", query: {sid: this.sid} })
        },
        //跳转到邀请好友页
        goSharePage(){
            if (this.cardInfo.cardInfo && this.cardInfo.cardInfo.isShare != 0) {
                this.$router.push({ name:"shareFriends", query: {sid: this.sid, 
                cardType: this.cardInfo && this.cardInfo.cardType} })
            } else {
                regularToast('该卡不支持共享')
            }
        },
        //跳转到连锁门店页
        goChainShopPage(){
            regularToast('暂未开放')
        },
        //跳转到优惠页
        goDiscountPage(){
            regularToast('暂未开放')
        },
        //跳转到预约页
        goPreOrderPage(){
            regularToast('暂未开放')
        },
        //跳转到消费记录页
        goXiaoFeiListPage()
        {
            this.$router.push({ name:"consumptionHistory", query: {sid: this.sid} });
        },
        // 获取单张二维码图片
        getQRcode()
        {
            
            if (this.active == false)
            {
                this.active = true;
            }
            else
            {
                this.active = false;
            }

            if (this.active || this.src)
            {
                return false;
            }

            this.src = 'https://app.cardeek.com/index.php?action=ShowMember&sid=' + this.cardInfo.sid + '&uid=' + this.cardInfo.uid
            console.log(this.src);
               
        },
        // 获取会员卡详情
        getCardDetailsInfo()
        {
          showCardAction(this.sid).then(res => {
                this.instance.close()
                console.log('会员卡信息',res);
                if (res.s == 0)
                {
                this.productsInfo = res.card.ys
                this.shopInfo = res.shop
                this.cardInfo = res.card
                this.activityInfo = res.activity
                this.actions = [{
                    name: '联系电话',
                }, {
                    name: '商家电话：' + ((typeof this.shopInfo.telephone === "undefined") ? '暂无电话' : this.shopInfo.telephone),
                    method: function () {
                        if (this.shopInfo && this.shopInfo.telephone) {
                            let callPhone = 'tel:' + this.shopInfo.telephone
                            window.open(callPhone)
                        }   
                    }
                }];
                }
          }).catch (err => {
              this.instance.close()
          })
        },
        loadMore()
        {
        },
    },
    created()
    {
        this.index = this.$route.query.index;
        this.sid = this.$route.query.sid;
    },
    mounted(){
        this.getCardDetailsInfo();
    },           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: auto;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
.cardInfo{
    height: auto;
    position: relative;
    margin-top: 0.2rem;
    background-color: #fff;
}
.shopName{
    font-size: 0.47rem;
    color: rgba(0, 0, 0, 0.7);
    position: relative;
    left: 38%;
    top: 0.32rem;
}
.bigPic{
    height: 5rem;
    position: relative;
}
.bigPic :nth-child(1){
    width: 4.1rem;
    height: 4.1rem;
    position: absolute;
    top: 0;
    left: 3.1rem;
}
.serial{
    font-size: 0.42rem;
    line-height: 0.61rem;
    text-align: center;
    color: rgba(16, 16, 16, 1);
    position: relative;
    top: 4.1rem;
}
.card,
.cardBack{
    height: 6.5rem;
    position: relative;
    top: 0.61rem;
    margin-bottom: 1.1rem;
}
.memberCard{
    width: 9.87rem;
    height: 6.05rem;
    border-radius: 0.5rem;
    background-color: rgba(41, 158, 173, 1);
    position: relative;
    color: #fff;
    font-size: 0.47rem;
}
.memberName{
    height: 0.94rem;
    padding-top: 0.43rem;
    width: 100%;
    border-bottom: 0.03rem solid rgba(187, 187, 187, 1);
}
.uname{
    float: left;
    position: relative;
    left: 0.42rem;
}
.cname{
    float: right;
    position: relative;
    right: 0.53rem;
}
.star{
    display: block;
    width: 0.24rem;
    height: 0.24rem;
    background: #ffffff;
    transform: rotate(45deg);
    position: relative;
    top: -0.2rem;
    left: 1.13rem;
}
.cInfo{
    position: relative;
}
.cInfo :nth-child(1){
    position: absolute;
    top: 0.92rem;
    left: 0.61rem;
}
.cInfo :nth-child(2){
    position: absolute;
    top: 0.92rem;
    left: 2.18rem;
}
.cInfo :nth-child(3){
    position: absolute;
    top: 0.92rem;
    right: 0.66rem;
}
.cInfo :nth-child(4){
    font-size: 0.95rem;
    position: absolute;
    top: 2rem;
    right: 0.66rem;
}
.cInfo :nth-child(5){
    font-size: 0.37rem;
    position: absolute;
    top: 2rem;
    left: 0.61rem;
}
/* 正面 */
.cardShare{
    font-size: 0.53rem;
    position: absolute;
    top: 0.26rem;
    right: 0.53rem;
}
.cImg{
    width: 9.87rem;
    height: 6.05rem;
}
.cardNum{
    font-size: 0.37rem;
    position: absolute;
    top: 5rem;
    left: 0.53rem;
}
.Qcode{
    width: 0.9rem;
    height: 0.9rem;
    position: relative;
    top: -0.4rem;
    left: 4.7rem;
}
.more{
    font-size: 0.37rem;
    position: relative;
    top: -0.55rem;
    left: 7.9rem;
}

.list{
    border: 0.03rem solid rgba(0, 0, 0, 0.2);
}
.list span{
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
}
.list ul li{
    height: 1.39rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.2);
}
.list ul li :nth-child(1){
    height: 0.63rem;
    width: 0.63rem;
    float: left;
    margin-left: 0.53rem;
    margin-top: 0.35rem;
}
.list ul li :nth-child(2){
    float: left;
    margin-left: 0.53rem;
    margin-top: 0.35rem;
}
.list ul li :nth-child(3){
    height: 0.53rem;
    width: 0.53rem;
    float: right;
    margin-right: 0.39rem;
    margin-top: 0.35rem;
}
.el-icon-arrow-right {
  font-size: 0.63rem;
  color: rgba(16, 16, 16, 1);
  font-weight: 600;
}
.select ul {
    height: 2.85rem;
}
.select ul li{
    height: 2.45rem;
    width: 1.12rem;
    background-color: #fff;
    float: left;
    border: 0.03rem solid rgba(0, 0, 0, 0.1); 
    padding-top: 0.34rem;
    padding-left: 0.63rem;
    padding-right: 0.68rem;
    position: relative;
    color: rgba(0, 0, 0, 0.7);
}
.select ul li :nth-child(1){
    width: 1.05rem;
    height: 1.05rem;
}
.select ul li :nth-child(2){
    position: absolute;
    top: 1.5rem;
    left: 0.53rem;
}
.select ul li :nth-child(3){
    position: absolute;
    top: 1.95rem;
    left: 0.53rem;
}
.yushou{
    font-size: 0.37rem;
    position: relative;
    top: 0.2rem;
    left: 0.55rem;
}
.yushouList{
    background-color: #ffffff;
    position: relative;
    top: 0.4rem;
    padding-top: 0.29rem;
    padding-bottom: 0.29rem;
    padding-left: 0.61rem;
    font-size: 0.37rem;
    line-height: 0.53rem;
    color: rgba(0, 0, 0, 0.9);
}
.yushouItem{
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
}
.yushouItem :nth-child(3){
    position: absolute;
    right: 0.53rem;
}
.area{
    font-size: 0.37rem;
    position: relative;
    top: 0.56rem;
    left: 0.55rem;
}
.activity{
    width: 100%;
    height: 7.71rem;
    position: relative;
    top: 0.8rem;
    padding-top: 0.4rem;
    background-color: #ffffff;
}
.activity ul li{
    margin-bottom: 0.4rem;
}
.item{
    position: relative;
    left: 0.37rem;
    width: 9.11rem;
    box-shadow: 0 0.08rem 0.37rem 0 rgba(187, 187, 187, 0.74);
}
.item :nth-child(1){
    width: 9.11rem;
    height: 4.29rem;
}
.explain{
    width: 9.11rem;
    height: 1.47rem;
    position: relative;
}
.explain :nth-child(1){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 0.26rem;
    left: 0.37rem;
}
.explain :nth-child(2){
    font-size: 0.32rem;
    color: rgba(0, 0, 0, 0.7);
    position: absolute;
    top: 0.84rem;
    left: 0.37rem;
}
.noData1{
    width: 100%;
    height: 5.58rem;
    text-align: center;
    position: relative;
    color: rgba(0, 0, 0, 0.5);
}
.icon-nodata {
    display: block;
    font-size: 2rem;
}
.noData1 :nth-child(2){
    font-size: 0.37rem;
    line-height: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/card/cardDetail.vue